import { FC, useState } from 'react';
import {
  NudosButton,
  NudosGenericModal,
  NudosModalContent,
  NudosTextInput
} from '../../../../../components/NudosComponents';
import LogisticsServiceTrelloCard from '../../LogisticsServiceTrelloCard/LogisticsServiceTrelloCard';
import { IlogisticServiceDetails, IlogisticServiceTrelloCardData, LOGISTIC_SERVICE_STATUS_NAME } from '../../../../../types/services';
import { CopyIcon } from 'assets/images/shopping';
import { displaySuccessNotification } from 'utils/displayNudosStandardNotifications';
import { copyInfoLS } from '../../../../../utils/copyInfoLS';
import { getNudosData } from '../../../../../utils/getNudosData';
import { TchangeLogisticServiceStatusCallback } from '../LogisticsServicesTrelloModals';

import './ConfirmedToProcess.scss';

interface IConfirmedToProcess {
  onlyItemCard: IlogisticServiceTrelloCardData;
  logisticServiceDetails?: IlogisticServiceDetails;
  closeModal?: () => void;
  closeAndRestoreList?: () => void;
  changeLogisticServiceStatus?: TchangeLogisticServiceStatusCallback;
  modalButtonIsLoading: boolean;
}

const ConfirmedToProcess: FC<IConfirmedToProcess> = ({
  closeModal,
  closeAndRestoreList,
  onlyItemCard,
  logisticServiceDetails,
  changeLogisticServiceStatus,
  modalButtonIsLoading
}: IConfirmedToProcess) => {
  const [providerName, setProviderName] = useState<string>();
  const [providerEmail, setProviderEmail] = useState<string>();
  const [ccEmails, setCcEmails] = useState<string[]>();

  const copyInfoDetails = async () => {
    if (logisticServiceDetails) {
      await copyInfoLS(logisticServiceDetails);
      displaySuccessNotification({ customJSXMessage: <>Se copió la información en el portapapeles.</> });
    }
  };

  const updateStatus = async () => {
    const currentNudosUser = getNudosData();
    if (!currentNudosUser?.userData?.id || !changeLogisticServiceStatus) return;

    const bodyNewStatus = {
      status: LOGISTIC_SERVICE_STATUS_NAME.INPROCESS,
      userId: Number(currentNudosUser.userData.id),
      inProcess: {
        deliveryProviderName: providerName,
        providerEmail: providerEmail,
        ccEmails: ccEmails
      }
    };
    await changeLogisticServiceStatus(bodyNewStatus, closeModal);
  };

  const getEmails = (input: string): { providerEmail: string; ccEmails: string[] } => {
    const inputWithoutSpaces = input.replaceAll(' ', '').split(',');
    return {
      providerEmail: inputWithoutSpaces[0],
      ccEmails: inputWithoutSpaces.slice(1, inputWithoutSpaces.length)
    };
  };

  return (
    <NudosGenericModal
      closeModalCallback={() => {
        if (closeAndRestoreList) {
          closeAndRestoreList();
        }
      }}
      clickOutsideCallback={() => {
        if (closeAndRestoreList) {
          closeAndRestoreList();
        }
      }}
      modalContent={
        <NudosModalContent
          noScroll
          customWidth="780px"
          customHeight="580px"
          modalContentTitle="Confirmado a En proceso"
          toCloseModal={() => {
            if (closeAndRestoreList) {
              closeAndRestoreList();
            }
          }}
          CustomModalComponent={
            <div id="confirmedToProcess">
              <div className="confirmedToProcessBox">
                <div className="title">Estás a punto de actualizar el estado del siguiente servicio:</div>
                <div className="cardContainerCenter">
                  <LogisticsServiceTrelloCard cardStatusColumnClassname="noMargin" logisticServiceData={onlyItemCard} />
                </div>
                <div className="containerForm">
                  <div className="boxContainerForm">
                    <div className="titleForm">Proveedor</div>
                    <div className="formProvider">
                      <div className="grayFormProvider">
                        <div>
                          <div>
                            <NudosTextInput
                              label="Nombre del proveedor*"
                              customClassName="customInput  mr-8"
                              placeholder="Escribe el nombre"
                              isFilled={!!providerName}
                              defaultValue={providerName}
                              handleChange={e => {
                                setProviderName(e);
                              }}
                            />
                            <div className="formNote">Este nombre se adjuntará en el correo</div>
                          </div>
                        </div>
                        <div>
                          <div>
                            <NudosTextInput
                              label="Correo del proveedor (opcional)"
                              customClassName="customInput"
                              placeholder="Escribe el correo"
                              isFilled={!!providerEmail}
                              defaultValue={providerEmail}
                              handleChange={e => {
                                const emails = getEmails(e);
                                setProviderEmail(emails.providerEmail);
                                setCcEmails(emails.ccEmails);
                              }}
                            />
                            <div className="formNote">Agrega más correos separando por comas</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="copyDetailInfo">
                      <div className="copyIcon">
                        <CopyIcon
                          stroke="#54A1FC"
                          onClick={() => {
                            copyInfoDetails();
                          }}
                        />
                      </div>
                      <div
                        onClick={() => {
                          copyInfoDetails();
                        }}
                        className="copyLabel"
                      >
                        Copiar datos del servicio en el portapapeles
                      </div>
                    </div>
                  </div>
                </div>
                <div className="containerSaveButton">
                  <NudosButton
                    isButtonDisabled={!providerName || modalButtonIsLoading}
                    customHeight="38px"
                    customWidth="400px"
                    isButtonLoading={modalButtonIsLoading}
                    buttonText="Guardar y enviar solicitud al proveedor"
                    handleClick={() => {
                      updateStatus();
                    }}
                  />
                </div>
              </div>
            </div>
          }
        />
      }
    />
  );
};

export default ConfirmedToProcess;
